import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceARCustomerActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Partner/PartnerBrowser")
	}

	render() {
		return (
			<Activity 
				menu="AR09"
				name="FinanceARCustomer"
				RenderedComponent={this.RenderedComponent}
				context="FinanceARCustomer"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceARCustomerActivity)
